import { useRole } from "./RoleContext";

const CanAccess = ({ allowedRoles, children, currentFolder, isFileUploadBtn= false}) => {
  const { role } = useRole();
  const hasAccess = isFileUploadBtn && ["franchise", "outlet"].includes(role) &&  currentFolder?.folderType == "outletInnerFolder"; 
  return allowedRoles.includes(role) || hasAccess ? children : null;
};

export default CanAccess;
